import React from "react";
import {dataForSelect, selectValue} from "../../../helpers/Api";
import {Button, Col, Row} from "react-bootstrap";
import {useQuery} from "@apollo/client";
import Select from "react-select";
import FlashMessage from "../../shared/FlashMessage";
import {UserContext} from "../../../context/UserContext";
import {getPlates} from "../plates/PlateQueries";

const MenuPlateForm = ({ menuPlate, onSubmit, flash }) => {
  const { categories } = React.useContext(UserContext);
  const { data } = useQuery(getPlates)

  return (
    <form onSubmit={onSubmit}>
      <input type='hidden' name='id' id="id" defaultValue={menuPlate.id} />
      <input type='hidden' name='menuId' id="menuId" defaultValue={menuPlate.menuId} />
      <Row className='mb-3'>
        <Col>
          <label htmlFor='plate'>Reteta</label>
          <Select name='plateId' id='plate' className="basic-single"
                  options={data && dataForSelect(data.plates)}
                  defaultValue={menuPlate.plate && selectValue(menuPlate.plate)}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <label htmlFor='day'>Ziua</label>
          <input type="number" name='day' id='day' defaultValue={1} className='form-control' />
        </Col>
        <Col>
          <label htmlFor='category'>Perioada zilei</label>
          <Select name='categoryId' id='category' className="basic-single"
                  options={dataForSelect(categories, ['name', 'time'])}
                  defaultValue={menuPlate.category && selectValue(menuPlate.category)}
          />
        </Col>
      </Row>
      <hr />
      <Row className='mb-3'>
        <FlashMessage flash={flash} buttons={
          <Button type='submit' className='float-end'>Salveaza</Button>} />
      </Row>
    </form>
  )
};

export default MenuPlateForm;
